module.exports = __webpack_public_path__ + "img/overview_plus.6b2af420.svg";